export const ALERT_TYPE_FILTER_ALL = 'all';
export const ALERT_TYPE_FILTER_FAILURE = 'fetch_failure';
export const ALERT_TYPE_FILTER_STALE = 'stale_content';

export const ALERT_TYPE_FILTER_OPTIONS = [
    ALERT_TYPE_FILTER_ALL,
    ALERT_TYPE_FILTER_FAILURE,
    ALERT_TYPE_FILTER_STALE,
];

export const ALERT_TYPE_FILTER_LABEL_IDS = {
    [ALERT_TYPE_FILTER_ALL]: 'monitoring.alerts.filter.all',
    [ALERT_TYPE_FILTER_FAILURE]: 'monitoring.alerts.filter.failure',
    [ALERT_TYPE_FILTER_STALE]: 'monitoring.alerts.filter.stale',
};

export function filterAlertsByType(alerts, alertTypeFilter) {
    if (alertTypeFilter === ALERT_TYPE_FILTER_ALL) {
        return alerts;
    }
    return alerts.filter((alert) => alert.alert_type === alertTypeFilter);
}
